Ext.ns('mx.data');

mx.data.JsonReader = Ext.extend(Ext.data.JsonReader, {
    read: function(response) {
        var s = this.meta;

        var json = response.responseText;
        var o = eval('(' + json + ')');
        if (!o) {
            throw {message: 'JsonReader.read: Json object not found'};
        }
        if (!o[this.meta.root]) {
            o[this.meta.root] = [];
        }
        var result = this.readRecords(o);
        if (o.errors) {
            result.errors = o.errors;
        }
        if (o.warnings) {
            result.warnings = o.warnings;
        }
        if (o.infos) {
            result.infos = o.infos;
        }
        if (s.collections) {
            for (var i = 0; i < s.collections.length; i++) {
                if (o[s.collections[i]]) {
                    result[s.collections[i]] = o[s.collections[i]];
                }
            }
        }

        var info = {};
        if (s.infoFields && s.infoFields.length) {
            for (var i = 0; i < s.infoFields.length; i++) {
                info[s.infoFields[i]] = this.getJsonAccessor(s.infoFields[i])(o);
            }
            result['info'] = info;
        }
        return result;
    },
    readPartialRecord: function(partialData) {
        var recordDiff = this.readRecords({rows: [partialData]}).records[0];
        for (k in recordDiff.data) {
            if (partialData[k] == undefined) {
                delete recordDiff.data[k];
            }
        }
        return recordDiff;
    },
});
mx.data.JsonReaderTranslator = Ext.extend(Ext.data.JsonReader, {
    read: function(response) {
        var json = response.responseText;
        var o = eval('(' + json + ')');
        if (!o) {
            throw {message: 'JsonReader.read: Json object not found'};
        }
        var result = this.readRecords(o);
        var dictionaryPrefix = this.meta.customParams ? this.meta.customParams['dictionaryPrefix'] || null : null;
        if (dictionaryPrefix) {
            for (var i = 0; i < result.records.length; i++) {
                var translate = MXBT.loc(dictionaryPrefix, result.records[i].get('title'));
                if (translate) {
                    result.records[i].set('title', translate);
                }
            }
        }
        if (o.errors) {
            result.errors = o.errors;
        }
        return result;
    },
});
mx.data.JsonEventReader = Ext.extend(mx.data.JsonReader, {
    /**
     * Create a data block containing Ext.data.Records from a JSON object.
     * @param {Object} o An object which contains an Array of row objects in the property specified
     * in the config as 'root, and optionally a property, specified in the config as 'totalProperty'
     * which contains the total size of the dataset.
     * @return {Object} data A data block which is used by an Ext.data.Store object as
     * a cache of Ext.data.Records.
     */
    readRecords: function(o) {
        /**
         * After any data loads, the raw JSON data is available for further custom processing.  If no data is
         * loaded or there is a load exception this property will be undefined.
         * @type Object
         */
        this.jsonData = o;
        if (o.metaData) {
            delete this.ef;
            this.meta = o.metaData;
            this.recordType = Ext.data.Record.create(o.metaData.fields);
            this.onMetaChange(this.meta, this.recordType, o);
        }
        var s = this.meta,
            Record = this.recordType,
            f = Record.prototype.fields,
            fi = f.items,
            fl = f.length;

        //      Generate extraction functions for the totalProperty, the root, the id, and for each field
        if (!this.ef) {
            if (s.totalProperty) {
                this.getTotal = this.getJsonAccessor(s.totalProperty);
            }
            if (s.successProperty) {
                this.getSuccess = this.getJsonAccessor(s.successProperty);
            }
            this.getRoot = s.root
                ? this.getJsonAccessor(s.root)
                : function(p) {
                      return p;
                  };
            if (s.id) {
                var g = this.getJsonAccessor(s.id);
                this.getId = function(rec) {
                    var r = g(rec);
                    return r === undefined || r === '' ? null : r;
                };
            } else {
                this.getId = function() {
                    return null;
                };
            }
            this.ef = [];
            for (var i = 0; i < fl; i++) {
                f = fi[i];
                var map = f.mapping !== undefined && f.mapping !== null ? f.mapping : f.name;
                this.ef[i] = this.getJsonAccessor(map);
            }
        }

        var root = this.getRoot(o),
            c = root.length,
            totalRecords = c,
            success = true,
            info = {};
        if (s.totalProperty) {
            var v = parseInt(this.getTotal(o), 10);
            if (!isNaN(v)) {
                totalRecords = v;
            }
        }
        if (s.successProperty) {
            var v = this.getSuccess(o);
            if (v === false || v === 'false') {
                success = false;
            }
        }
        var records = [];
        for (var i = 0; i < c; i++) {
            var n = root[i];
            var values = {};
            var id = this.getId(n);
            for (var j = 0; j < fl; j++) {
                f = fi[j];
                var v = this.ef[j](n);
                if (f.name == 'record' && n['recordClass']) {
                    var type = eval(n['recordClass']);
                    if (type) {
                        var data = n['recordData'];
                        type.prototype.fields.each(function(field) {
                            var val = data[field.name];
                            if (val) {
                                data[field.name] = field.convert(data[field.name]);
                            }
                        });
                        values[f.name] = new type(data);
                    }
                } else {
                    values[f.name] = f.convert(v !== undefined ? v : f.defaultValue, n);
                }
            }
            var record = new Record(values, id);
            record.json = n;
            records[i] = record;
        }
        return {
            success: success,
            records: records,
            totalRecords: totalRecords,
        };
    },
});
